export class ContatoMensagem {
  id: number;
  nome: string = '';
  email: string = '';
  telefone: string = '';
  mensagem: string = '';
  assunto: string = '';
}
